/**
 * Analytics abstraction — provider-agnostic interface.
 *
 * Currently wraps Google Analytics 4 (gtag).  Structured so additional
 * providers (Plausible, Fathom, PostHog) can be plugged in later without
 * touching the calling code.
 *
 * Usage:
 *   analytics.pageView(location.pathname)
 *   analytics.track('newsletter_signup', { source: 'homepage' })
 */

const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || '';

let bootstrapped = false;

function ensureGA4Loaded() {
  if (bootstrapped || !MEASUREMENT_ID || typeof window === 'undefined') return;

  // Inject the gtag script
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, {
    send_page_view: false, // We fire page_view manually via analytics.pageView()
    anonymize_ip: true,
  });

  bootstrapped = true;
}

export const analytics = {
  isEnabled: () => !!MEASUREMENT_ID,

  boot: () => ensureGA4Loaded(),

  pageView: (path) => {
    ensureGA4Loaded();
    if (!MEASUREMENT_ID || !window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  },

  track: (event, params = {}) => {
    ensureGA4Loaded();
    if (!MEASUREMENT_ID || !window.gtag) return;
    window.gtag('event', event, params);
  },
};

export default analytics;
